import {
  Adjustments,
  Briefcase,
  Edit,
  Plus,
  Search,
} from "tabler-icons-react";
import routeNames from "../../../routes/routeNames";

export const links = [
  {
    label: "Search Job",
    link: routeNames.general.search,
    icon: <Plus color="white" />,
  },
  {
    label: "Employer Sign Up",
    link: routeNames.general.employer,
    icon: <Briefcase color="white" />,
  },
  {
    label: "Job Seeker Sign Up",
    link: routeNames.general.jobSeeker,
    icon: <Search color="white" />,
  },
  {
    label: "About Us",
    link: routeNames.general.aboutUs,
    icon: <Search color="white" />,
  },
  {
    label: "Contact Us",
    link: routeNames.general.contactus,
    icon: <Search color="white" />,
  },
];
export const internalLinks = [
  {
    label: "Edit Profile",
    link: routeNames.general.myProfile,
    icon: <Edit size={22} />,
  },
  {
    label: "Settings",
    link: routeNames.general.settings,
    icon: <Adjustments size={22} />,
  },
];
